import styled from '@emotion/styled';
import { Link } from 'components/link';
import { Text } from 'ds/components/typography';

export const Root = styled.div``;

export const DeveloperLink = styled(Link)(({ theme }) => ({
  color: theme.colors.brand.main,
  textDecoration: 'none',
}));

export const DeveloperLinkText = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const HeaderWrapper = styled.div<{ isMobile: boolean; }>(({ isMobile, theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  ...(isMobile ? {
    flexDirection: 'column',
    marginTop: theme.spacing(2),
  } : {}),
}));

export const Title = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));
